// extracted by mini-css-extract-plugin
module.exports = {"buttonsBar":"buttonsBar_buttonsBar__JYa2g","accept":"buttonsBar_accept__2T3lU","reject":"buttonsBar_reject__2N-fw","snooze":"buttonsBar_snooze__2QBUr"};